import { ChangeEvent, Textbox } from "@mcleod/components";
import { AutogenLayoutDriverChoicePreferences } from "./autogen/AutogenLayoutDriverChoicePreferences";

export class DriverChoicePreferences extends AutogenLayoutDriverChoicePreferences {
    onChangeTopPriority(event: ChangeEvent) {
        const textbox = event.target as Textbox;
        if (textbox.selectedItem?.value != null) {
            if ("ED" == textbox.selectedItem.value) {
                this.labelPriorityOneLG.text = "less than";
                this.labelPriorityOneMD.text = "miles";
                this.textboxChoicePriority1Value.maxValue = null;
            }
            else if ("MR" == textbox.selectedItem.value) {
                this.labelPriorityOneLG.text = "greater than";
                this.labelPriorityOneMD.text = "dollars";
                this.textboxChoicePriority1Value.maxValue = 9999.99;
            }
        }
    }

    onChangeNextPriority(event: ChangeEvent) {
        const textbox = event.target as Textbox;
        if (textbox.selectedItem?.value != null) {
            if ("ED" == textbox.selectedItem.value) {
                this.labelPriorityTwoLG.text = "less than";
                this.labelPriorityTwoMD.text = "miles";
                this.textboxChoicePriority2Value.maxValue = null;
            }
            else if ("MR" == textbox.selectedItem.value) {
                this.labelPriorityTwoLG.text = "greater than";
                this.labelPriorityTwoMD.text = "dollars";
                this.textboxChoicePriority2Value.maxValue = 9999.99;
            }
        }
        else {
            this.textboxChoicePriority2Value.clear();
        }
    }
}
